import { DeleteEvent, GetEvent, PatchEvent, SubmitEvent } from '~/machines/base-crud/events';
import { deleteData, getData, patchData, postData } from '~/utils/service';

import { Certification } from '~/types/mcv/certification';
import { CertFormValues, GridContext } from './types';
import {
  transformCertsToFormValue,
  transformCertToFormValue,
  transformFormValuesToCert,
} from './utils';

const ROUTE_NAME = 'certifications';

interface CertGridInput<T> {
  input: {
    context: GridContext;
    event: T;
  };
}

export const CERT_ROUTES = {
  get: '/certifications/{providerId}',
  post: '/certifications',
  patch: '/certifications/{id}',
  delete: '/certifications/{id}',
};

export const API_CALLS = {
  get: async ({ input }: CertGridInput<GetEvent>): Promise<Certification[]> => {
    return await getData(ROUTE_NAME, {
      pathParams: { providerId: input.context.providerId.toString() },
      transformResponse: transformCertsToFormValue,
    });
  },
  create: async ({ input }: CertGridInput<SubmitEvent<CertFormValues>>): Promise<Certification> => {
    return await postData(ROUTE_NAME, {
      data: input.event.values,
      transformRequest: transformFormValuesToCert,
      transformResponse: transformCertToFormValue,
    });
  },
  delete: async ({ input }: CertGridInput<DeleteEvent>) => {
    return await deleteData(ROUTE_NAME, {
      pathParams: { id: input.event.payload.id.toString() },
    });
  },
  patch: async ({ input }: CertGridInput<PatchEvent<CertFormValues>>): Promise<Certification> => {
    return await patchData(ROUTE_NAME, {
      pathParams: { id: input.event.values.id?.toString() || '' },
      data: input.event.values,
      transformRequest: transformFormValuesToCert,
      transformResponse: transformCertToFormValue,
    });
  },
};
